<template>
	<div class="Ausbilder">
		<div class="container">
			<h1>{{ $t('navigationAusbilder.title') }}</h1>
			<div class="row align-items-center">
				<div class="py-5 col-9">
					<h2>
						{{ $t('navigationAusbilder.ausbilder.ausbilder1.name') }}
					</h2>
					<div class="mb-3">
						<a href="mailto:info@sos-p.com">{{
							$t('navigationAusbilder.ausbilder.ausbilder1.email')
						}}</a>
					</div>
					<h5>
						{{ $t('navigationAusbilder.qualifikationTitle') }}
					</h5>
					<ul>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder1.qualifikationen.qualifikation1'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder1.qualifikationen.qualifikation2'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder1.qualifikationen.qualifikation3'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder1.qualifikationen.qualifikation4'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder1.qualifikationen.qualifikation5'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder1.qualifikationen.qualifikation6'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder1.qualifikationen.qualifikation7'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder1.qualifikationen.qualifikation8'
								)
							}}
						</li>
					</ul>
					<h5>
						{{ $t('navigationAusbilder.graduierungTitle') }}
					</h5>
					<ul>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder1.graduierungen.graduierung1'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder1.graduierungen.graduierung2'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder1.graduierungen.graduierung3'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder1.graduierungen.graduierung4'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder1.graduierungen.graduierung5'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder1.graduierungen.graduierung6'
								)
							}}
						</li>
					</ul>
				</div>

				<div class="py-5 col-9">
					<h2>
						{{ $t('navigationAusbilder.ausbilder.ausbilder2.name') }}
					</h2>
					<div class="mb-4">
						<a href="mailto:info@selfprotection.de">{{
							$t('navigationAusbilder.ausbilder.ausbilder2.email')
						}}</a>
					</div>
					<h5>
						{{ $t('navigationAusbilder.qualifikationTitle') }}
					</h5>
					<ul>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder2.qualifikationen.qualifikation1'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder2.qualifikationen.qualifikation2'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder2.qualifikationen.qualifikation3'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder2.qualifikationen.qualifikation4'
								)
							}}
						</li>
					</ul>
					<h5>
						{{ $t('navigationAusbilder.graduierungTitle') }}
					</h5>
					<ul>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder2.graduierungen.graduierung1'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder2.graduierungen.graduierung2'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder2.graduierungen.graduierung3'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder2.graduierungen.graduierung4'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder2.graduierungen.graduierung5'
								)
							}}
						</li>
            <li>
              {{
                $t(
                  'navigationAusbilder.ausbilder.ausbilder2.graduierungen.graduierung6'
                )
              }}
            </li>
            <li>
              {{
                $t(
                  'navigationAusbilder.ausbilder.ausbilder2.graduierungen.graduierung7'
                )
              }}
            </li>
					</ul>
				</div>

				<div class="py-5 col-9">
					<h2>
						{{ $t('navigationAusbilder.ausbilder.ausbilder3.name') }}
					</h2>
					<div class="mb-4">
						<a href="mailto:info@matac.net">{{
							$t('navigationAusbilder.ausbilder.ausbilder3.email')
						}}</a>
					</div>
					<h5>
						{{ $t('navigationAusbilder.qualifikationTitle') }}
					</h5>
					<ul>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder3.qualifikationen.qualifikation1'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder3.qualifikationen.qualifikation2'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder3.qualifikationen.qualifikation3'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder3.qualifikationen.qualifikation4'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder3.qualifikationen.qualifikation5'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder3.qualifikationen.qualifikation6'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder3.qualifikationen.qualifikation7'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder3.qualifikationen.qualifikation8'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder3.qualifikationen.qualifikation9'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder3.qualifikationen.qualifikation10'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder3.qualifikationen.qualifikation11'
								)
							}}
						</li>
					</ul>
					<h5>
						{{ $t('navigationAusbilder.graduierungTitle') }}
					</h5>
					<ul>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder3.graduierungen.graduierung1'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder3.graduierungen.graduierung2'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder3.graduierungen.graduierung3'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbilder.ausbilder.ausbilder3.graduierungen.graduierung4'
								)
							}}
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Ausbilder',
	i18n: {
		messages: {
			de: require('@/i18n/de/de_ausbilder.json'),
			en: require('@/i18n/en/eng_ausbilder.json')
		}
	}
}
</script>

<style scoped lang="stylus">
a {
	color: red;
}
</style>
